import { ISelectOption } from '../../../components/forms/Select';
import { IRadioOption } from '../../../components/forms/RadioGroup';
import { IRadioCardOption } from '../../../components/forms/RadioCardGroup';

export const CASHME_MIN_MAIN_MONTHLY_INCOME = 4_000;
export const CASHME_MIN_GRACE_PERIOD = 1;

export const PERSON_TYPE_OPTIONS: IRadioOption[] = [
  { value: 'natural', label: 'Você' },
  { value: 'legal', label: 'Sua empresa' },
];

export const INTEREST_TABLE_OPTIONS = [
  { value: 'PRICE', label: 'PRICE' },
  { value: 'SAC', label: 'SAC' },
];

export const MONETARY_CORRECTION_OPTIONS: IRadioOption[] = [
  { value: 'PRE_FIXED', label: 'Prefixado' },
  { value: 'POST_FIXED', label: 'Pós-fixado' },
];

export const INDEX_OPTIONS: IRadioOption[] = [
  { value: 'IPCA', label: 'IPCA' },
  { value: 'CDI', label: 'CDI' },
];

export const graceOptions = (maxMonths: number): IRadioOption[] =>
  Array.from(
    { length: Math.max(0, maxMonths - CASHME_MIN_GRACE_PERIOD + 1) },
    (_, offset) => {
      const months = CASHME_MIN_GRACE_PERIOD + offset;
      return {
        value: String(months),
        label: months === 1 ? '1 mês' : `${months} meses`,
      };
    }
  );

export const COLLATERAL_TYPE_OPTIONS: IRadioCardOption[] = [
  { value: 'HOUSE', label: 'Casa', icon: 'home' },
  { value: 'APARTMENT', label: 'Apartamento', icon: 'apartment' },
  { value: 'COMMERCIAL_PROPERTY', label: 'Comercial', icon: 'store' },
  { value: 'LAND', label: 'Terreno', icon: 'landscape' },
  { value: 'PARKING_SPOT', label: 'Vaga de garagem', icon: 'local_parking' },
];

export const CREDIT_PURPOSE_OPTIONS: ISelectOption[] = [
  { value: 'DEBT_PAYMENT', label: 'Quitar dívidas' },
  { value: 'INVESTMENT', label: 'Investimento' },
  { value: 'WORKING_CAPITAL', label: 'Capital de giro' },
  { value: 'HOME_REFORM', label: 'Reforma do imóvel' },
  { value: 'HOME_PURCHASE', label: 'Compra de imóvel' },
  { value: 'OTHER', label: 'Outro' },
];

export const MARITAL_STATUS_OPTIONS: ISelectOption[] = [
  { value: 'SINGLE', label: 'Solteiro(a)' },
  { value: 'MARRIED', label: 'Casado(a)' },
  { value: 'DIVORCED', label: 'Divorciado(a)' },
  { value: 'WIDOWER', label: 'Viúvo(a)' },
  { value: 'SEPARATED', label: 'Separado(a)' },
];

export const MATRIMONIAL_REGIME_OPTIONS: ISelectOption[] = [
  { value: 'COMUNHAO_DE_BENS', label: 'Comunhão de bens' },
  { value: 'COMUNHAO_PARCIAL_DE_BENS', label: 'Comunhão parcial de bens' },
  { value: 'COMUNHAO_UNIVERSAL_DE_BENS', label: 'Comunhão universal de bens' },
  { value: 'SEPARACAO_DE_BENS', label: 'Separação de bens' },
  { value: 'SEPARACAO_PARCIAL', label: 'Separação parcial' },
  {
    value: 'SEPARACAO_OBRIGATORIA_DE_BENS',
    label: 'Separação obrigatória de bens',
  },
];

export const INCOME_TYPE_OPTIONS: ISelectOption[] = [
  { value: 'EMPLOYEE', label: 'Assalariado(a)' },
  { value: 'ENTREPRENEUR', label: 'Empresário(a)' },
  { value: 'SELF_EMPLOYED', label: 'Autônomo(a)' },
  { value: 'PENSIONER', label: 'Aposentado(a) ou pensionista' },
  { value: 'CIVIL_SERVANT', label: 'Servidor(a) público(a)' },
  { value: 'SERVICE_PROVIDER', label: 'Prestador(a) de serviços' },
  { value: 'LIBERAL_PROFESSIONAL', label: 'Profissional liberal' },
  { value: 'LANDLORD', label: 'Rentista' },
  { value: 'HOMEMAKER', label: 'Do lar' },
];

export const COMPANY_TYPE_OPTIONS: ISelectOption[] = [
  { value: 'MICRO_ENTERPRISE', label: 'Microempresa' },
  { value: 'LIMITED_COMPANY', label: 'Sociedade limitada' },
  { value: 'INDIVIDUAL_COMPANY', label: 'Empresa individual' },
  { value: 'JOIN_STOCK_COMPANY', label: 'Sociedade anônima' },
  { value: 'CIVIL_SOCIETY', label: 'Sociedade civil' },
  {
    value: 'DOMESTIC_GOVERNMENTAL_ENTITY',
    label: 'Entidade governamental',
  },
];

export const ANNUAL_BILLING_OPTIONS: ISelectOption[] = [
  { value: 'LESS_THAN_300_MILLIONS', label: 'Até R$ 300 milhões' },
  { value: 'MORE_THAN_300_MILLIONS', label: 'Acima de R$ 300 milhões' },
];

export const YES_NO_OPTIONS: IRadioOption[] = [
  { value: 'true', label: 'Sim' },
  { value: 'false', label: 'Não' },
];

export const UF_OPTIONS: ISelectOption[] = [
  'AC',
  'AL',
  'AP',
  'AM',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MT',
  'MS',
  'MG',
  'PA',
  'PB',
  'PR',
  'PE',
  'PI',
  'RJ',
  'RN',
  'RS',
  'RO',
  'RR',
  'SC',
  'SP',
  'SE',
  'TO',
].map((uf) => ({ value: uf, label: uf }));
